/* Avinos reviews - V145 (26 okt 2026): ongewijzigd verplaatst uit sections/avinos-reviews.liquid (stond daar inline). */
  (function () {
    'use strict';

    /* --------------------------------------------------------------------
       Registered once per page; every copy of the section reuses it.
       Binding by element id was fragile: during a theme-editor re-render the
       outgoing and incoming sections briefly share an id, so getElementById
       could hand back the stale node and the fresh one would never start.
       initAll() scans the document instead, so no re-render path can miss it.
       -------------------------------------------------------------------- */
    if (window.__avinosReviews) { window.__avinosReviews.init(); return; }

    /* Per-instance state lives inside this closure, so two copies of the
       section on one page never share state. */
    function initAvinosReviews(root) {
      if (!root || root.getAttribute('data-avr-ready') === 'true') return;
      root.setAttribute('data-avr-ready', 'true');

      var listEl      = root.querySelector('[data-avr-list]');
      var emptyEl     = root.querySelector('[data-avr-empty]');
      var emptyMsgEl  = root.querySelector('[data-avr-empty-msg]');
      var moreBtn     = root.querySelector('[data-avr-more]');
      var resultsEl   = root.querySelector('[data-avr-results]');
      var sortEl      = root.querySelector('[data-avr-sort]');
      var photosBtn   = root.querySelector('[data-avr-photos]');
      var thisProdBtn = root.querySelector('[data-avr-thisproduct]');
      var formPanel   = root.querySelector('[data-avr-form]');
      var formOpenBtn = root.querySelector('[data-avr-form-open]');
      var barsEl      = root.querySelector('[data-avr-bars]');
      var lightbox    = root.querySelector('[data-avr-lightbox]');
      var lightboxImg = root.querySelector('[data-avr-lbimg]');
      var lbCloseBtn  = root.querySelector('[data-avr-lbclose]');
      var clearBtns   = root.querySelectorAll('[data-avr-clear]');

      if (!listEl) return;

      /* Mobiel start met minder reviews. De grens ligt op 749px, gelijk aan
         de breakpoint die de rest van dit thema gebruikt. */
      var isMobile = window.matchMedia
        ? window.matchMedia('(max-width: 749px)').matches
        : false;
      var perPageAttr = isMobile ? 'data-per-page-mobile' : 'data-per-page';
      var perPage = parseInt(root.getAttribute(perPageAttr), 10);
      if (!perPage || perPage < 1) perPage = parseInt(root.getAttribute('data-per-page'), 10) || 5;

      var productFirst = root.getAttribute('data-product-first') === 'true';

      var VOTES_KEY = root.getAttribute('data-votes-key') || 'avinos_reviews_votes';
      var FLAGS_KEY = VOTES_KEY.replace('_votes_', '_flags_');

      var reduceMotion = window.matchMedia
        ? window.matchMedia('(prefers-reduced-motion: reduce)').matches
        : false;

      /* ---- build the item array from the rendered DOM --------------------
         V123: in een functie, want na het lazy laden komen er kaarten bij
         en moet de lijst opnieuw worden opgebouwd.                          */
      var cards = [];
      var items = [];
      var matchCount = 0;
      function collect() {
        cards = Array.prototype.slice.call(root.querySelectorAll('[data-avr-card]'));
        items = cards.map(function (el, i) {
          var raw = el.getAttribute('data-date') || '';
          var parsed = raw ? Date.parse(raw) : NaN;
          var idx = parseInt(el.getAttribute('data-index'), 10);
          return {
            el: el,
            index: isNaN(idx) ? i : idx,
            id: el.getAttribute('data-block-id') || String(i),
            rating: parseInt(el.getAttribute('data-rating'), 10) || 0,
            photos: el.getAttribute('data-photos') === 'true',
            match: el.getAttribute('data-product-match') === 'true',
            ts: isNaN(parsed) ? null : parsed
          };
        });
        matchCount = items.filter(function (it) { return it.match; }).length;
      }
      collect();

      var state = {
        starFilter: null,
        photosOnly: false,
        thisProductOnly: false,
        sort: 'recent',
        visibleCount: perPage
      };

      /* ---- storage helpers (Safari private mode throws on write) ------- */
      function readStore(key, store) {
        try {
          var raw = (store || window.localStorage).getItem(key);
          var obj = raw ? JSON.parse(raw) : null;
          return (obj && typeof obj === 'object') ? obj : {};
        } catch (e) {
          return {};
        }
      }
      function writeStore(key, value, store) {
        try {
          (store || window.localStorage).setItem(key, JSON.stringify(value));
        } catch (e) { /* storage unavailable: the in-memory object still works */ }
      }
      function sessionStore() {
        try { return window.sessionStorage; } catch (e) { return null; }
      }

      var votes = readStore(VOTES_KEY);
      var flags = readStore(FLAGS_KEY, sessionStore());

      /* ---- sorting ------------------------------------------------------
         Unparseable dates fall back to the block's authored index order so a
         malformed date string can never break the sort.                      */
      function byDateDesc(a, b) {
        if (a.ts !== null && b.ts !== null && a.ts !== b.ts) return b.ts - a.ts;
        if (a.ts !== null && b.ts === null) return -1;
        if (a.ts === null && b.ts !== null) return 1;
        return a.index - b.index;
      }
      var baseComparators = {
        recent: byDateDesc,
        highest: function (a, b) { return (b.rating - a.rating) || byDateDesc(a, b); },
        lowest:  function (a, b) { return (a.rating - b.rating) || byDateDesc(a, b); }
      };

      /* Reviews over het product dat de bezoeker bekijkt komen bovenaan. Binnen
         die twee groepen geldt gewoon de gekozen sortering. Iemand die naar een
         jas kijkt hoort niet eerst drie reviews over sandalen te lezen. */
      function withProductFirst(cmp) {
        return function (a, b) {
          if (productFirst && a.match !== b.match) return a.match ? -1 : 1;
          return cmp(a, b);
        };
      }
      var comparators = {
        recent:  withProductFirst(baseComparators.recent),
        highest: withProductFirst(baseComparators.highest),
        lowest:  withProductFirst(baseComparators.lowest)
      };

      function getFiltered() {
        var out = items.filter(function (it) {
          if (state.starFilter !== null && it.rating !== state.starFilter) return false;
          if (state.photosOnly && !it.photos) return false;
          if (state.thisProductOnly && !it.match) return false;
          return true;
        });
        return out.sort(comparators[state.sort] || byDateDesc);
      }

      function filtersActive() {
        return state.starFilter !== null || state.photosOnly || state.thisProductOnly || state.sort !== 'recent';
      }

      /* ---- V123: lazy laden van de rest van de reviews ------------------
         De pagina bevat alleen de lichte set. ensureAll() haalt de volledige
         sectie op via de Section Rendering API (zelfde product, met
         ?variant= als schakelaar, zie de uitleg bovenaan), voegt de kaarten
         toe die nog ontbreken en bouwt de lijst opnieuw op. Wordt een keer
         uitgevoerd; daarna is het een no-op.
         GEEN Accept-header meesturen: met Accept: application/json geeft
         Shopify het product als JSON terug in plaats van de sectie.       */
      var fullUrl = root.getAttribute('data-avr-full-url') || '';
      var complete = root.getAttribute('data-avr-complete') === 'true' || !fullUrl;
      var loading = null;

      function isComplete() { return complete; }

      function ensureAll() {
        if (complete) return Promise.resolve(true);
        if (loading) return loading;
        var sectionId = (root.closest('[id^="shopify-section-"]') || {}).id;
        sectionId = sectionId ? sectionId.replace('shopify-section-', '') : '';
        loading = fetch(fullUrl, { credentials: 'same-origin' })
          .then(function (r) { if (!r.ok) throw new Error('avr ' + r.status); return r.json(); })
          .then(function (json) {
            var html = '';
            if (json && sectionId && typeof json[sectionId] === 'string') html = json[sectionId];
            else if (json) { for (var k in json) { if (typeof json[k] === 'string' && json[k].indexOf('data-avr-root') !== -1) { html = json[k]; break; } } }
            if (!html || html.indexOf('data-avr-root') === -1) throw new Error('avr empty');
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var incoming = doc.querySelectorAll('[data-avr-card]');
            var have = {};
            cards.forEach(function (c) { have[c.getAttribute('data-block-id')] = true; });
            var frag = document.createDocumentFragment();
            var added = [];
            Array.prototype.forEach.call(incoming, function (c) {
              var id = c.getAttribute('data-block-id');
              if (!id || have[id]) return;
              var node = document.importNode(c, true);
              node.hidden = true;
              frag.appendChild(node);
              added.push(node);
            });
            listEl.appendChild(frag);
            complete = true;
            root.setAttribute('data-avr-complete', 'true');
            collect();
            added.forEach(function (card) { paintVotes(card); paintFlag(card); });
            paintAvatars();
            if (thisProdBtn && matchCount > 0) thisProdBtn.hidden = false;
            render(false);
            return true;
          })
          .catch(function (err) {
            if (window.console && console.warn) console.warn('Avinos reviews: could not load all reviews', err);
            loading = null;
            return false;
          });
        return loading;
      }

      /* Haal de rest alvast op zodra de sectie in de buurt van het scherm
         komt (1200px marge), zodat een tik op Read all meteen alles toont.
         Niet tijdens het laden van de pagina zelf: dat zou de meting en de
         eerste weergave weer zwaarder maken. */
      if (!complete && 'IntersectionObserver' in window) {
        var preIo = new IntersectionObserver(function (entries, obs) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            obs.disconnect();
            var go = function () { ensureAll(); };
            if ('requestIdleCallback' in window) window.requestIdleCallback(go, { timeout: 2000 });
            else window.setTimeout(go, 200);
          });
        }, { rootMargin: '1200px 0px' });
        preIo.observe(root);
      }

      function busy(btn, on) {
        if (!btn) return;
        if (on) btn.setAttribute('aria-busy', 'true'); else btn.removeAttribute('aria-busy');
      }

      /* ---- render ------------------------------------------------------- */
      var previouslyVisible = {};

      function render(animateNew) {
        var list = getFiltered();
        var shown = list.slice(0, state.visibleCount);
        var nowVisible = {};

        items.forEach(function (it) {
          it.el.hidden = true;
          it.el.classList.remove('avr-card--last', 'avr-card--enter');
          it.el.style.order = '';
        });

        shown.forEach(function (it, idx) {
          it.el.hidden = false;
          it.el.style.order = String(idx);
          nowVisible[it.id] = true;
          if (animateNew && !previouslyVisible[it.id] && !reduceMotion) {
            it.el.classList.add('avr-card--enter');
          }
          if (idx === shown.length - 1) it.el.classList.add('avr-card--last');
        });

        previouslyVisible = nowVisible;

        var isEmpty = list.length === 0;
        var noneAtAll = items.length === 0;
        listEl.hidden = isEmpty;
        if (emptyEl) emptyEl.hidden = !isEmpty;
        if (emptyMsgEl) {
          emptyMsgEl.textContent = noneAtAll
            ? 'No reviews yet.'
            : 'No reviews match these filters.';
        }

        /* Zolang niet alles geladen is, blijft Show more zichtbaar: er is
           altijd meer dan de lichte set. */
        if (moreBtn) moreBtn.hidden = isEmpty || ((list.length - shown.length) <= 0 && complete);

        if (resultsEl) {
          resultsEl.textContent = 'Showing ' + shown.length + ' of ' + list.length +
            ' review' + (list.length === 1 ? '' : 's');
        }

        Array.prototype.forEach.call(clearBtns, function (btn) {
          if (btn.closest('[data-avr-empty]')) return;
          btn.hidden = !filtersActive();
        });

        if (barsEl) {
          Array.prototype.forEach.call(barsEl.querySelectorAll('[data-avr-bar]'), function (bar) {
            var v = parseInt(bar.getAttribute('data-avr-bar'), 10);
            bar.setAttribute('aria-pressed', state.starFilter === v ? 'true' : 'false');
          });
        }
        if (photosBtn) photosBtn.setAttribute('aria-pressed', state.photosOnly ? 'true' : 'false');
        if (thisProdBtn) thisProdBtn.setAttribute('aria-pressed', state.thisProductOnly ? 'true' : 'false');
        if (sortEl && sortEl.value !== state.sort) sortEl.value = state.sort;
      }

      /* ---- scroll back to the top of the section, only if off-screen ---- */
      function maybeScroll() {
        var rect = root.getBoundingClientRect();
        var offScreen = rect.top < 0 || rect.top > (window.innerHeight || 0);
        if (!offScreen) return;
        try {
          root.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
        } catch (e) {
          root.scrollIntoView(true);
        }
      }

      function applyFilterChange() {
        state.visibleCount = perPage;
        previouslyVisible = {};
        render(false);
        maybeScroll();
      }

      /* Filters en sortering hebben de volledige lijst nodig. */
      function withAll(btn, fn) {
        if (complete) { fn(); return; }
        busy(btn, true);
        ensureAll().then(function () { busy(btn, false); fn(); });
      }

      /* ---- votes -------------------------------------------------------- */
      function paintVotes(card) {
        var id = card.getAttribute('data-block-id');
        var vote = votes[id] || null;
        var btns = card.querySelectorAll('[data-avr-vote]');
        Array.prototype.forEach.call(btns, function (btn) {
          var kind = btn.getAttribute('data-avr-vote');
          var base = parseInt(btn.getAttribute('data-base'), 10) || 0;
          var countEl = btn.querySelector('[data-avr-votecount]');
          var isActive = vote === kind;
          if (countEl) countEl.textContent = String(base + (isActive ? 1 : 0));
          btn.setAttribute('aria-pressed', isActive ? 'true' : 'false');
          btn.disabled = (vote !== null && !isActive);
        });
      }

      function toggleVote(card, kind) {
        var id = card.getAttribute('data-block-id');
        if (votes[id] === kind) {
          delete votes[id];
        } else {
          votes[id] = kind;
        }
        writeStore(VOTES_KEY, votes);
        paintVotes(card);
      }

      /* ---- flags -------------------------------------------------------- */
      function paintFlag(card) {
        var id = card.getAttribute('data-block-id');
        if (!flags[id]) return;
        var link = card.querySelector('[data-avr-flag]');
        if (!link || !link.hasAttribute('href')) return;
        link.removeAttribute('href');
        link.setAttribute('aria-disabled', 'true');
        link.classList.add('avr-flag--done');
        link.textContent = 'Reported';
      }

      /* ---- deterministic avatar colour from the reviewer's name --------- */
      function paintAvatars() {
        Array.prototype.forEach.call(root.querySelectorAll('[data-avr-avatar]'), function (el) {
          var card = el.closest('[data-avr-card]');
          var name = (card && card.getAttribute('data-author')) || '';
          var hash = 0;
          for (var i = 0; i < name.length; i++) {
            hash = (hash * 31 + name.charCodeAt(i)) % 360;
          }
          el.style.backgroundColor = 'hsl(' + hash + ', 32%, 90%)';
          el.style.color = 'hsl(' + hash + ', 38%, 26%)';
        });
      }

      /* ---- lightbox ----------------------------------------------------- */
      var lbTrigger = null;

      function openLightbox(src, alt, trigger) {
        if (!lightbox || !lightboxImg) return;
        lbTrigger = trigger || null;
        lightboxImg.src = src;
        lightboxImg.alt = alt || '';
        lightbox.setAttribute('data-open', 'true');
        document.addEventListener('keydown', onLightboxKey);
        if (lbCloseBtn) lbCloseBtn.focus();
      }
      function closeLightbox() {
        if (!lightbox) return;
        lightbox.setAttribute('data-open', 'false');
        lightboxImg.src = '';
        document.removeEventListener('keydown', onLightboxKey);
        if (lbTrigger && document.contains(lbTrigger)) lbTrigger.focus();
        lbTrigger = null;
      }
      function onLightboxKey(e) {
        if (e.key === 'Escape' || e.key === 'Esc') closeLightbox();
      }
      if (lightbox) {
        lightbox.addEventListener('click', function (e) {
          if (e.target === lightbox || e.target.hasAttribute('data-avr-lbclose')) closeLightbox();
        });
      }

      /* ---- single delegated click handler on the section root ----------- */
      root.addEventListener('click', function (e) {
        var t = e.target;
        if (!t || !t.closest) return;

        var bar = t.closest('[data-avr-bar]');
        if (bar && root.contains(bar)) {
          if (bar.disabled) return;
          var v = parseInt(bar.getAttribute('data-avr-bar'), 10);
          withAll(bar, function () {
            state.starFilter = (state.starFilter === v) ? null : v;
            applyFilterChange();
          });
          return;
        }

        if (photosBtn && t.closest('[data-avr-photos]')) {
          withAll(photosBtn, function () {
            state.photosOnly = !state.photosOnly;
            applyFilterChange();
          });
          return;
        }

        if (thisProdBtn && t.closest('[data-avr-thisproduct]')) {
          withAll(thisProdBtn, function () {
            state.thisProductOnly = !state.thisProductOnly;
            applyFilterChange();
          });
          return;
        }

        if (t.closest('[data-avr-clear]')) {
          withAll(t.closest('[data-avr-clear]'), function () {
            state.starFilter = null;
            state.photosOnly = false;
            state.thisProductOnly = false;
            state.sort = 'recent';
            if (sortEl) sortEl.value = 'recent';
            applyFilterChange();
          });
          return;
        }

        if (t.closest('[data-avr-more]')) {
          withAll(moreBtn, function () {
            state.visibleCount += perPage;
            render(true);
          });
          return;
        }

        var voteBtn = t.closest('[data-avr-vote]');
        if (voteBtn && root.contains(voteBtn)) {
          if (voteBtn.disabled) return;
          var vCard = voteBtn.closest('[data-avr-card]');
          if (vCard) toggleVote(vCard, voteBtn.getAttribute('data-avr-vote'));
          return;
        }

        var readMore = t.closest('[data-avr-readmore]');
        if (readMore && root.contains(readMore)) {
          var rCard = readMore.closest('[data-avr-card]');
          var body = rCard && rCard.querySelector('[data-avr-body]');
          if (!body) return;
          var expanded = readMore.getAttribute('aria-expanded') === 'true';
          body.classList.toggle('avr-body--clamped', expanded);
          readMore.setAttribute('aria-expanded', expanded ? 'false' : 'true');
          readMore.textContent = expanded ? 'Read more' : 'Read less';
          return;
        }

        var thumb = t.closest('[data-avr-thumb]');
        if (thumb && root.contains(thumb)) {
          var img = thumb.querySelector('img');
          openLightbox(thumb.getAttribute('data-full'), img ? img.alt : '', thumb);
          return;
        }

        var flag = t.closest('[data-avr-flag]');
        if (flag && root.contains(flag)) {
          var fCard = flag.closest('[data-avr-card]');
          if (fCard) {
            /* build the full mailto (subject + prefilled body) right before the
               browser follows the link - see the PERF note in the markup */
            if (flag.hasAttribute('href') && flag.getAttribute('href').indexOf('?') === -1) {
              var enc = function (v) { return encodeURIComponent(v || '').replace(/%0A/g, '%0D%0A'); };
              var fMail = root.getAttribute('data-flag-mail') || '';
              var fProduct = root.getAttribute('data-flag-product') || '';
              var fAuthor = fCard.getAttribute('data-author') || '';
              var fSubject = 'Flagged Review — ' + fProduct + ' — ' + fAuthor;
              var fBody = 'Product: ' + fProduct + '\n' +
                'Product URL: ' + (root.getAttribute('data-flag-url') || '') + '\n' +
                'Review by: ' + fAuthor + '\n' +
                'Review date: ' + (fCard.getAttribute('data-date') || '') + '\n' +
                'Review rating: ' + (fCard.getAttribute('data-rating') || '') + '\n' +
                'Review ID: ' + (fCard.getAttribute('data-block-id') || '') + '\n\n' +
                'Reason for flagging:\n';
              flag.setAttribute('href', 'mailto:' + fMail + '?subject=' + enc(fSubject) + '&body=' + enc(fBody));
            }
            flags[fCard.getAttribute('data-block-id')] = 1;
            writeStore(FLAGS_KEY, flags, sessionStore());
            /* let the mailto default action fire before neutralising the link */
            window.setTimeout(function () { paintFlag(fCard); }, 60);
          }
        }
      });

      if (sortEl) {
        sortEl.addEventListener('change', function () {
          var next = sortEl.value || 'recent';
          withAll(null, function () {
            state.sort = next;
            applyFilterChange();
          });
        });
      }

      /* ---- rating bar fill animation (once, on first scroll into view) -- */
      var fills = root.querySelectorAll('[data-avr-fill]');
      function paintBars(animate) {
        if (animate && barsEl) barsEl.classList.add('avr-bars--animate');
        Array.prototype.forEach.call(fills, function (f) {
          f.style.width = (parseFloat(f.getAttribute('data-pct')) || 0) + '%';
        });
      }
      if (reduceMotion || !('IntersectionObserver' in window) || !barsEl) {
        paintBars(false);
      } else {
        /* Widths are already correct from Liquid; reset to 0 only now that we
           know JS is running and will animate them back. */
        Array.prototype.forEach.call(fills, function (f) { f.style.width = '0%'; });
        var io = new IntersectionObserver(function (entries, obs) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            paintBars(true);
            obs.disconnect();
          });
        }, { threshold: 0.25 });
        io.observe(barsEl);
      }

      /* ---- first paint --------------------------------------------------- */
      cards.forEach(function (card) {
        paintVotes(card);
        paintFlag(card);
      });
      paintAvatars();

      /* De pill heeft alleen zin als er ook echt reviews over dit product zijn.
         (Alle reviews over dit product zitten altijd in de lichte set.) */
      if (thisProdBtn) {
        if (matchCount > 0) thisProdBtn.hidden = false;
        else thisProdBtn.remove();
      }

      /* ---- write a review: open, close, focus -------------------------- */
      function setFormOpen(open) {
        if (!formPanel || !formOpenBtn) return;
        formPanel.hidden = !open;
        formOpenBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
        if (open) {
          var first = formPanel.querySelector('input, textarea, select, button');
          if (first && first.focus) first.focus({ preventScroll: true });
          formPanel.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'nearest' });
        } else {
          formOpenBtn.focus();
        }
      }
      if (formOpenBtn && formPanel) {
        formOpenBtn.addEventListener('click', function () {
          setFormOpen(formPanel.hidden);
        });
        root.addEventListener('click', function (e) {
          if (e.target.closest('[data-avr-form-close]')) {
            e.preventDefault();
            setFormOpen(false);
          }
        });
        root.addEventListener('keydown', function (e) {
          if (e.key === 'Escape' && !formPanel.hidden) setFormOpen(false);
        });
      }

      /* Shopify stuurt na het verzenden terug naar dezelfde pagina. Staat er een
         bevestiging of een foutmelding in het paneel, dan klappen we het open
         en scrollen we ernaartoe - anders zou de klant niets zien gebeuren. */
      if (formPanel) {
        var posted = formPanel.querySelector('[data-avr-form-done]');
        var failed = formPanel.querySelector('[data-avr-form-error]');
        if (posted || failed) {
          formPanel.hidden = false;
          if (formOpenBtn) formOpenBtn.setAttribute('aria-expanded', 'true');
          window.setTimeout(function () {
            formPanel.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'center' });
          }, 120);
        }
      }

      render(false);

      /* V123: hooks voor snippets/avinos-reviews-compact.liquid */
      root.avrEnsureAll = ensureAll;
      root.avrIsComplete = isComplete;
      root.avrRender = function () { render(false); };

      /* ---- theme editor: reveal + scroll to the selected review block ---- */
      root.avrSelectBlock = function (blockId) {
        state.starFilter = null;
        state.photosOnly = false;
        var list = getFiltered();
        var pos = -1;
        for (var i = 0; i < list.length; i++) {
          if (list[i].id === blockId) { pos = i; break; }
        }
        if (pos >= 0) state.visibleCount = Math.max(perPage, pos + 1);
        render(false);
        var target = root.querySelector('[data-block-id="' + blockId + '"]');
        if (target) {
          try {
            target.scrollIntoView({ behavior: 'smooth', block: 'center' });
          } catch (e) { /* older browsers */ }
        }
      };
    }

    /* ---- initialise every un-initialised instance in the document ----- */
    function initAll() {
      var roots = document.querySelectorAll('[data-avr-root]');
      for (var i = 0; i < roots.length; i++) {
        try {
          initAvinosReviews(roots[i]);
        } catch (err) {
          if (window.console && console.warn) console.warn('Avinos reviews: init failed', err);
        }
      }
    }

    /* ---- theme editor --------------------------------------------------
       Every re-render re-scans the document, so it no longer matters whether
       the inline script re-executed, which element the event targeted, or
       whether a stale copy is still attached to the page.                  */
    document.addEventListener('shopify:section:load', initAll);
    document.addEventListener('shopify:section:select', initAll);
    document.addEventListener('shopify:block:select', function (e) {
      initAll();
      var card = e.target && e.target.closest ? e.target.closest('[data-avr-card]') : null;
      if (!card) return;
      var host = card.closest('[data-avr-root]');
      if (host && typeof host.avrSelectBlock === 'function') {
        host.avrSelectBlock(card.getAttribute('data-block-id'));
      }
    });

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll, { once: true });
    }

    /* ---- theme editor safety net ---------------------------------------
       The editor swaps section markup in ways that don't always line up with
       the documented events, and inline scripts inserted that way may never
       re-execute. In the editor only, watch for a section being attached and
       initialise it directly. Never runs on the live storefront.           */
    if (window.Shopify && window.Shopify.designMode && 'MutationObserver' in window) {
      var pending = null;
      var observer = new MutationObserver(function (mutations) {
        for (var m = 0; m < mutations.length; m++) {
          var added = mutations[m].addedNodes;
          for (var n = 0; n < added.length; n++) {
            var node = added[n];
            if (!node || node.nodeType !== 1) continue;
            var isRoot = node.matches && node.matches('[data-avr-root]');
            var hasRoot = node.querySelector && node.querySelector('[data-avr-root]');
            if (isRoot || hasRoot) {
              if (pending) window.clearTimeout(pending);
              pending = window.setTimeout(function () { pending = null; initAll(); }, 0);
              return;
            }
          }
        }
      });
      observer.observe(document.documentElement, { childList: true, subtree: true });
    }

    window.__avinosReviews = { init: initAll };
    initAll();
  })();
